import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { NewPermitComponent } from './new-permit.component';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { PodFormComponent } from './components/pod-form/pod-form.component';
import { VarianceFormComponent } from './components/variance-form/variance-form.component';
import { ApplicationFormComponent } from './components/application-form/application-form.component';
import { AopFormComponent } from './components/aop-form/aop-form.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AopGroupComponent } from './components/aop-group/aop-group.component';
import { StatusColumnComponent } from './components/status-column/status-column.component';
import { ProjectFacilityStatusGroupComponent } from './components/project-facility-status-group/project-facility-status-group.component';
import { ReachNameDisplayPipe } from './pipes/reach-name-display.pipe';
import { SharedModule } from '../../modules/shared/shared.module';

@NgModule({
  declarations: [
    NewPermitComponent,
    PodFormComponent,
    VarianceFormComponent,
    ApplicationFormComponent,
    AopFormComponent,
    AopGroupComponent,
    StatusColumnComponent,
    ProjectFacilityStatusGroupComponent,
    ReachNameDisplayPipe
  ],
  imports: [
    CommonModule,
    SharedModule,
    NgMultiSelectDropDownModule,
    RouterModule.forChild([
      { path: 'new-permit', component: NewPermitComponent },
      { path: 'permit-status/:appPackageId/:permitAopId', component: NewPermitComponent },
      { path: 'permit-variance/:appPackageId/:permitAopId', component: NewPermitComponent },
      { path: 'permit-facilities/:appPackageId/:permitAopId', component: NewPermitComponent }
    ]),
    FormsModule,
    NgbModule
  ],
  exports: [NewPermitComponent, PodFormComponent, VarianceFormComponent, ApplicationFormComponent, AopFormComponent, AopGroupComponent, StatusColumnComponent, ProjectFacilityStatusGroupComponent]
})
export class NewPermitModule { }
